import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ListeProprietesComponent } from './containers/liste-proprietes/liste-proprietes.component';
import { FormulaireProprieteComponent } from './containers/formulaire-propriete/formulaire-propriete.component';
import { ProprieteGuard } from './propriete-guard.service';
import { ProprieteComponent } from './propriete.component';
import { PageIntroductionComponent } from './components/page-introduction/page-introduction.component';
import { PropertyDetailsComponent } from './containers/property-details/property-details.component';

const proprieteRoutes: Routes = [
  {
    path: '',
    component: ProprieteComponent,
    children: [
      {
        path: '',
        redirectTo: 'liste',
        pathMatch: 'full'
      },
      {
        path: 'liste',
        component: ListeProprietesComponent,
        canActivate: [ProprieteGuard]
      },
      {
        path: 'creation-propriete',
        component: FormulaireProprieteComponent,
        canActivate: [ProprieteGuard],
        data: { breadcrumb: 'breadcrumb.propriete.creation' }
      },
      {
        path: 'estimation-propriete',
        component: PageIntroductionComponent,
        data: { breadcrumb: 'breadcrumb.propriete.estimer' }
      },
      {
        path: 'detail/:id',
        component: PropertyDetailsComponent,
        canActivate: [ProprieteGuard],
        data: { breadcrumb: 'breadcrumb.propriete.detail' }
      },
      {
        path: 'modifier/:id',
        component: FormulaireProprieteComponent,
        canActivate: [ProprieteGuard],
        data: { breadcrumb: 'breadcrumb.propriete.modifier' }
      },
      {
        path: '**',
        component: ListeProprietesComponent,
        canActivate: [ProprieteGuard]
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(proprieteRoutes)],
  exports: [RouterModule]
})
export class ProprieteRoutingModule {}
